/* eslint-disable */
import ko from 'knockout';
import _ from 'underscore';
import ko_schema from '@bingads-webui-component-legacy/ko-schema/index';
import constants from '@bingads-webui-static-legacy/ad-constants/adConstants';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');
var s$AppInstallAd = window.globalLegacySchema.get('AppInstallAd');
var appPlatformKeys = {
  'Android': i18n.get('AppInstall_Platform_Android'),
  'iOS': i18n.get('AppInstall_Platform_iOS'),
  'Windows Phone': i18n.get('AppInstall_Platform_WinPhone'),
  'Windows': i18n.get('AppInstall_Platform_Windows')
};
var ViewModel = function (options) {
  var self = this;
  this.options = options || ({});
  var appPlatformsEnum = s$AppInstallAd.properties.AppPlatform.enum;
  if (appPlatformsEnum.indexOf('Windows Phone') > -1) {
    appPlatformsEnum.splice(appPlatformsEnum.indexOf('Windows Phone'), 1);
  }
  if (appPlatformsEnum.indexOf('Windows') > -1) {
    appPlatformsEnum.splice(appPlatformsEnum.indexOf('Windows'), 1);
  }
  this.appPlatforms = _.map(appPlatformsEnum, function (key) {
    return {
      Name: appPlatformKeys[key],
      Value: key
    };
  });
  this.noResultsFound = ko.observable(false);
  this.isSearchEnabled = ko.observable(true);
  this.appSearchResults = ko.observableArray([]);
  this.appPlatform = ko.observable(this.options.appPlatform || '');
  this.searchTerm = ko.observable('');
  this.appStoreId = ko.observable('');
  this.appStoreIdMaxLength = constants.maxAppStoreIdLength;
  this.applookupLoggingInformation = '';
  this.isSearchEnabled.Editing = ko.computed({
    read: function () {
      return this.isSearchEnabled().toString();
    },
    write: function (newValue) {
      var result = newValue === 'true';
      this.setApplookupLoggingInformation(result);
      this.clearAppLookupInfo();
      return this.isSearchEnabled(result);
    }
  }, this);
  this.appIdError = ko.computed(function () {
    if (self.isSearchEnabled()) {
      return;
    }
    var errorMessage = '';
    if (self.appPlatform() === 'iOS' && self.appStoreId()) {
      var urlRegex = new RegExp('^\\d+$', 'i');
      errorMessage = urlRegex.test(self.appStoreId()) ? '' : i18n.get('AppInstall_Validation_Digit_Only');
    }
    return errorMessage;
  });
  this.appIdLabel = ko.computed(function () {
    if (self.isSearchEnabled()) {
      return '';
    }
    var labelText = i18n.get('AppInstall_App_Id');
    if (self.appPlatform() === 'Android') {
      labelText = i18n.get('AppInstall_Package_Name');
    }
    return labelText;
  });
  this.appPlatform.subscribe(function (newValue) {
    self.appSearchResults.removeAll();
  });
  this.toManualObject = function () {
    return {
      'AppPlatform': self.appPlatform(),
      'AppStoreId': self.appStoreId(),
      'ApplookupLoggingInformation': self.applookupLoggingInformation + ' - Manual app store id (' + this.appStoreId() + ')'
    };
  };
  this.clearAppLookupInfo = function () {
    this.noResultsFound(false);
    this.searchTerm('');
    this.appSearchResults.removeAll();
    this.appStoreId('');
  };
  this.setApplookupLoggingInformation = function (isSearched) {
    if (isSearched) {
      this.applookupLoggingInformation += '-> App Search option selected ';
      if (this.searchTerm()) {
        this.applookupLoggingInformation += '-> Search Term (' + this.searchTerm() + ') - ' + (this.noResultsFound() ? ' NO RESULTS FOUND ' : ' RESULTS FOUND. ');
      }
    } else {
      this.applookupLoggingInformation += '-> Manual app option selected ';
    }
  };
};
ViewModel.prototype.bindAppData = function (data) {
  var isNoResultFound = _.size(data) == 0;
  this.noResultsFound(isNoResultFound);
  this.setApplookupLoggingInformation(true);
  if (isNoResultFound) {
    this.appSearchResults.removeAll();
    return;
  }
  var self = this;
  _.each(data, function (appData) {
    self.appSearchResults.push(appData);
  });
};
ViewModel.prototype.handleErrors = function (response) {
  var self = this;
  this.noResultsFound(true);
  this.appSearchResults.removeAll();
  if (response.errorResponseBody && response.errorResponseBody.value) {
    var errs = response.errorResponseBody.value;
    _.each(errs, function (err) {
      if (_.has(self, err.Property)) {
        self[err.Property].errors.push(response.i18nErrors(err, i18n));
      }
    });
  }
};
export default ViewModel;

